import React from 'react';
import { Card, Button, Col } from 'react-bootstrap';
import { renderMarkdown } from './renderMarkdown';
import { useAuth } from '../../AuthContext';

function ChallengeCard({ challenge, onSelect, onDelete }) {
    const { user } = useAuth();
    const isOwner = !!user && challenge.created_by === user.username;
    const isRoot = user?.rank === 'root';
    const canDelete = isOwner || isRoot;
    const isRootOverride = isRoot && !isOwner;

    return (
        <Col lg={4} md={6} sm={12} className="training-grid-col">
            <Card
                onClick={() => onSelect(challenge)}
                className="training-challenge-card"
            >
                <Card.Body className="training-card-content">
                    <Card.Title className="training-card-heading">{challenge.title}</Card.Title>
                    <div
                        className={`training-category-tag ${challenge.category === 'Full Pwn' ? 'training-category-fullpwn' : ''}`}
                        style={challenge.category === 'Full Pwn' ? {
                            boxShadow: '0 0 20px #FF1744, 0 0 40px #FF1744, 0 0 60px #FF1744',
                            animation: 'pulse 2s infinite'
                        } : {}}
                    >
                        {challenge.category}
                    </div>
                    <div className={`training-difficulty-tag training-difficulty-${challenge.difficulty}`}>
                        {challenge.difficulty}
                    </div>
                    <div className="training-card-desc" style={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        display: '-webkit-box',
                        WebkitLineClamp: 3,
                        WebkitBoxOrient: 'vertical',
                        maxHeight: '4.5em',
                        lineHeight: '1.5em'
                    }}>
                        {renderMarkdown(challenge.description)}
                    </div>
                    {challenge.file_link && (
                        <Button
                            variant="link"
                            href={challenge.file_link}
                            target="_blank"
                            className="training-file-link"
                        >
                            Download File
                        </Button>
                    )}
                    {canDelete && (
                        <Button
                            variant={isRootOverride ? 'dark' : 'danger'}
                            size="sm"
                            className={`training-delete-button${isRootOverride ? ' training-delete-button--root' : ''}`}
                            title={isRootOverride ? 'Delete as root (not your challenge)' : 'Delete challenge'}
                            onClick={(e) => {
                                e.stopPropagation();
                                onDelete(challenge.id);
                            }}
                        >
                            ×
                        </Button>
                    )}
                </Card.Body>
                <Card.Footer className="training-card-footer">
                    <small>Created by: {challenge.created_by}</small>
                    <small className="ms-2">Flags: {challenge.flags?.length || 1}</small>
                </Card.Footer>
            </Card>
        </Col>
    );
}

export default ChallengeCard;
